
import { defineComponent } from "vue-demi";

const __default__ = defineComponent({
  name: "Spinner",
  props: {
    speed: {
      type: String,
      default: "2s",
    },
  },
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars((_vm, _setup) => ({
  "8391dee8": (_vm.speed)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__